export default __webpack_public_path__ + "static/media/business.65af9346.svg";